import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams,Link } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import { Layout, Row, Col, Form, Select, Button, Collapse, Spin,Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import PhoneInput from "react-phone-input-2";

import InputField from "../../common/htmlComponents/InputField";
import EmailField from "../../common/htmlComponents/EmailField";
import { authUserData } from "../../utils/Helper";
import { Trans } from "react-i18next";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import NewPermissionPanelStep from "../../authentication/steps/NewPermissionPanelStep";

const { Content } = Layout;

const { Option } = Select;

const mockData = Array.from({
  length: 20,
}).map((_, i) => ({
  key: i.toString(),
  title: `content${i + 1}`,
  description: `description of content${i + 1}`,
}));
const initialTargetKeys = mockData
  .filter((item) => Number(item.key) > 10)
  .map((item) => item.key);
const AddEmployee = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { id } = useParams();
  const EmployeeId = id ? id : null;
  const { Panel } = Collapse;

  const Admin = authUserData()?.company_role;

  const [defaultCategory, setDefaultCategory] = useState(null);
  const [identifyProfileUrl, setIdentifyProfileUrl] = useState(null);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [fileList, setFileList] = useState([]);

  const [seniorEmployee, setSeniorEmployee] = useState([]);
  const [apiLoading, setapiloading] = useState(false);
  const hasPermission = authUserData()?.role[0].name;

  const [btnLoading, setBtnLoading] = useState(false);

  const [roleName, setRoleName] = useState([]);

  const [categoryTree, setCategoryTree] = useState([]);

  const [siteEmployee, setSiteEmployee] = useState([]);
  const [permissionDatas, setPermissionDatas] = useState([]);

  const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    employee_id: "",
    role: [],
    permission: [],
    category_tree: [1],
    senior_employee: null,
    assign_site_employee: [],
  };
  const [state, setState] = useState(initialState);
  const navigate = useNavigate();

  const [targetKeys, setTargetKeys] = useState(initialTargetKeys);
  const onChange = (nextTargetKeys, direction, moveKeys) => {
    setTargetKeys(nextTargetKeys);
  };
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;
  const vendorId = authUserData()?.vendor ? authUserData()?.vendor : null;
  const phoneValidLength = state?.phone;


  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }

    return Promise.resolve();
  };
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const getSenior = async (data) => {
    await getRequest(
      "employee/employees-by-company/?no_pagination=True",
      data
    ).then((response) => {
      setSeniorEmployee(response.data.results.data);
    });
  };
  const handleSeniorChange = (values) => {
    setState({ ...state, senior_employee: values });
  };

  const getRoleName = async (data) => {
    if (CompanyId) {
      await getRequest(
        `get-group/?no_pagination=True&company_id=${CompanyId}`
      ).then((response) => {
        setRoleName(response.data.data);
      });
    } else {
      await getRequest(`get-group/?vendor_id=${vendorId}`, data).then(
        (response) => {
          setRoleName(response.data.results.data);
        }
      );
    }
  };
  const getCategoryTree = async (data) => {
    await getRequest("category-tree/?no_pagination=True", data).then(
      (response) => {
        setCategoryTree(response.data.data);
        const cementCategory = response.data.data.find(
          (category) => category.name === "Cement"
        );
        if (cementCategory) {
          setDefaultCategory(cementCategory.id);
        }
      }
    );
  };
  const getPermissionByRole = async (id) => {
    let comAdmin = Admin === "Company Admin" ? Admin : null;
    let venAdmin = Admin === "Vendor Admin" ? Admin : null;

    let payload = null;

    if (comAdmin) {
      payload = {
        role_name: comAdmin,
        employee_id: EmployeeId,
        group_ids: id,
      };
    } else {
      payload = {
        role_name: venAdmin,
        employee_id: EmployeeId,
        group_ids: id,
      };
    }

    try {
      const permissionResponse = await patchRequest(
        "list-permission/group-wise-permission/",
        payload
      );

      setTargetKeys(permissionResponse.data.data.map((item) => item.id));
      setState((prevState) => {
        const updatedPermissions = permissionResponse.data.data
          .filter((item) => item.is_checked === true)
          .map((item) => item.permission_id);
        return {
          ...prevState,
          role: id,
          permission: updatedPermissions,
        };
      });

      setPermissionDatas(permissionResponse.data.data);
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const getPermission = async () => {
    try {
      setapiloading(true);
      let permissionArray;

      permissionArray = await getRequest(
        `create-group-permissions/get-group-permission-by-user/`
      );
      if (permissionArray.data.success) {
        if (permissionArray.data.response) {
          setPermissionDatas(permissionArray.data.data);
        }
        setapiloading(false);
      }
      setapiloading(false);
    } catch (error) {
      setapiloading(false);
      ErrorNotificationMsg("Error fetching permissions");
    }
  };

  const groupedPermissions = permissionDatas?.reduce((groups, permission) => {
    const { model_name } = permission;
    if (!groups[model_name]) {
      groups[model_name] = [];
    }
    groups[model_name].push(permission);
    return groups;
  }, {});

  useEffect(() => {
    const employeeGetById = async () => {
      try {
        const apiResponse = await getRequest(`employee/${EmployeeId}/`);

        if (apiResponse.data.success) {
          const {
            id,
            senior_employee,
            created_by,
            updated_by,
            ...filteredResponse
          } = apiResponse.data.data;

          formRef.current.setFieldsValue({
            ...apiResponse.data.data,
            employee_id: apiResponse.data.data.employe_id,
            first_name: apiResponse.data.data.first_name,
            last_name: apiResponse.data.data.last_name,
            email: apiResponse.data.data.email,
            phone: String(apiResponse.data.data.phone),
            role: apiResponse.data.data.groups.map((group) => group.role),
            senior_employee: apiResponse.data.data.senior_employee,
            assign_site_employee:
              apiResponse.data.data.assign_site_employee.map((site) => site.id),
          });
          const roles = apiResponse.data.data.groups.map((group) => group.role);
          getPermissionByRole(roles);

          setState({
            ...filteredResponse,
            phone: String(apiResponse.data.data.phone),
          });

          const url = apiResponse.data.data.profile_photo;
          setIdentifyProfileUrl(apiResponse.data.data.profile_photo);
          if (url !== null) {
            setFileList([
              {
                url: url,
              },
            ]);
          }
        }
      } catch (error) {
        ErrorNotificationMsg(t("error_in_list_employee"));
      }
    };
    if (EmployeeId !== null) {
      employeeGetById();
    }

    getRoleName();
    getSenior();
    getCategoryTree();
    if (hasPermission !== "Super Admin" && hasPermission !== "Vendor Admin") {
      getSite();
    }
  }, [EmployeeId, t]);
  const getSite = async (data) => {
    await getRequest("employee/site-by-company/?no_pagination=True", data).then(
      (response) => {
        setSiteEmployee(response.data.results.data);
      }
    );
  };

  const handleRoleSelectChange = (value) => {
    if (value.length > 0) {
      getPermissionByRole(value);
    } else {
      setPermissionDatas([]);
    }
  };
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };

  const handleSubmit = async () => {
    state.assign_site_employee.map((item) => {
      //console.log('dd', item);
    });

    const assignSiteEmployeeIds = state.assign_site_employee.map(
      (site) => site.id
    );
    const payload = {
      employe_id: state.employee_id ?? "N/A",
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      phone: state.phone,
      role: state.role,
      permission: state.permission,
      senior_employee: state.senior_employee,
      assign_site_employee: assignSiteEmployeeIds,
    };

    const payload2 = {
      employe_id: state.employee_id ?? "N/A",
      first_name: state.first_name,
      last_name: state.last_name,
      email: state.email,
      phone: state.phone,
      role: state.role,
      permission: state.permission,
      senior_employee: state.senior_employee,
      assign_site_employee: assignSiteEmployeeIds,
    };

    try {
      setBtnLoading(true);
      let response;

      const formData = new FormData();
      formData.append("profile_photo", uploadFileProfilePic);
      if (EmployeeId === null) {
        formData.append("form_data", JSON.stringify(payload));
      } else {
        formData.append("form_data", JSON.stringify(payload2));
      }

      if (EmployeeId === null) {
        response = await postRequest("employee/", formData);
      } else {
        response = await patchRequest(`employee/${EmployeeId}/`, formData);
      }

      if (response.data.success) {
        SuccessNotificationMsg(
          EmployeeId === null
            ? t("employee_added_successfully")
            : t("employee_updated_successfully")
        );
        setState(initialState);
        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        updateSubscriptionStatus();
        navigate("/employee");
      }
    } catch (error) {
      if (EmployeeId === null) {
        ErrorNotificationMsg(t("error_in_adding_employee"));
      }
      if (EmployeeId !== null && !error?.message) {
        ErrorNotificationMsg(t("error_in_updating_employee"));
      }

      setBtnLoading(false);
    }
  };

  const handleSiteChange = (selectedSiteIds) => {
    const selectedSites = selectedSiteIds
      .map((id) => {
        const site = siteEmployee.find((site) => site.site_id === id);
        return site ? { id: site.site_id, site_name: site.site_name } : null;
      })
      .filter((site) => site !== null);
    setState({ ...state, assign_site_employee: selectedSites });
  };

  const handleChangePr = (name, value) => {
    setState({ ...state, [name]: value });
  };

  return (
    <>
            <div className="ListingTopBar">
            <div className="pagenamewrap">
              <div className="pagename">
              {EmployeeId ? (
                      <h3> Edit User </h3>
                    ) : (
                      <h3> Add User </h3>
                    )}
               
    
                <Breadcrumb className="Breadcrumb-Sec">
                  <Breadcrumb.Item>
                    <Link to="/dashboard">Dashboard</Link>
                  </Breadcrumb.Item>
       {EmployeeId ? (
                 <Breadcrumb.Item>Edit User</Breadcrumb.Item>
              ) : (
                <Breadcrumb.Item>Add User</Breadcrumb.Item>
              )}
                 
                 
                </Breadcrumb>
                </div>
         
              
            </div>
          </div>
      
      
          <Form onFinish={handleSubmit} autoComplete="off" ref={formRef} className="stepscontentwrap">
         
               
                
                  <div className="stepsContent">
                      <Spin spinning={apiLoading}>
                    <div className="formwrapper">
                      <div className="formrowsection">
                        <Collapse defaultActiveKey={["1"]} onChange={onChange}>
                          <Panel header="Personal Info" key="1">
                            <Row gutter={16}>
                              <Col
                                xs={24}
                                sm={24}
                                md={12}
                                lg={8}
                                xxl={6}
                                className="TextFeild gutter-row"
                              >
                                <InputField
                                  name="first_name"
                                  label={t("label_firstName")}
                                  placeholder={t("pl_firstName")}
                                  rules={t("val_name")}
                                  value={state.first_name}
                                  pattern={"^[a-zA-Z ]+$"}
                                  handleInputChange={handleInputChange}
                                  max={30}
                                />
                              </Col>

                              <Col xs={24} sm={24} md={12} lg={8} xxl={6}>
                             
                                  {" "}
                                  <InputField
                                    name="last_name"
                                    label={t("label_lastName")}
                                    placeholder={t("pl_lastName")}
                                    pattern={"^[a-zA-Z ]+$"}
                                    rules={t("val_name")}
                                    value={state.last_name}
                                    handleInputChange={handleInputChange}
                                    max={30}
                                  />
                              
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={8} xxl={6}>
                             
                                  {" "}
                                  <EmailField
                                    name="email"
                                    label={t("label_email")}
                                    placeholder="Enter email"
                                    rules={t("val_email")}
                                    value={state.email}
                                    handleInputChange={handleInputChange}
                                  />
                             
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={8} xxl={6}>
                                <Form.Item
                                  name="phone"
                                  label={t("Contact Number")}
                                  placeholder={t("pl_mobileNumber")}
                                  rules={[
                                    {
                                      required: true,
                                      validator: validatePhoneNumber,
                                      message: (
                                        <Trans> {t("val_mobileNumber")}</Trans>
                                      ),
                                    },
                                  ]}
                                >
                                  <div className="phonefield">
                                    <PhoneInput
                                      country={"in"}
                                      className="PhoneSection"
                                      value={state.phone}
                                      onChange={(phone) =>
                                        setState({ ...state, phone: phone })
                                      }
                                    />
                                  </div>
                                </Form.Item>
                              </Col>
                              <Col xs={24} sm={24} md={12} lg={8} xxl={6}>
                                
                                  <InputField
                                    name="employee_id"
                                    // rules={t("Please enter employee Id")}
                                    label={t("label_employeeId")}
                                    placeholder="Enter Employee Id"
                                    value={state.employee_id || ""}
                                    handleInputChange={handleInputChange}
                                    max={50}
                                  />
                              
                              </Col>

                              {seniorEmployee && seniorEmployee.length > 0 && (
                                <Col
                                  xs={24}
                                  sm={24}
                                  md={12}
                                  lg={8}
                                  xxl={6}
                                  className="TextFeild gutter-row"
                                >
                                  <Form.Item
                                    name="senior_employee"
                                    label="Line Manager/ Workflow Approver"
                                    rules={[
                                      {
                                        required:
                                          !!seniorEmployee &&
                                          seniorEmployee.length > 1,
                                        message: "Please enter senior",
                                      },
                                    ]}
                                  >
                                    {seniorEmployee &&
                                      seniorEmployee.length > 0 && (
                                        <Select
                                          className="cust-selectBox"
                                          showArrow
                                          showSearch
                                          allowClear
                                          placeholder="Select line manager"
                                          optionFilterProp="children"
                                          onChange={handleSeniorChange}
                                          value={state.senior_employee}
                                        >
                                          {seniorEmployee.map((item) => (
                                            <Select.Option
                                              key={item.id}
                                              value={item.id}
                                            >
                                              {`${item.first_name} ${item.last_name}`}
                                            </Select.Option>
                                          ))}
                                        </Select>
                                      )}
                                  </Form.Item>
                                </Col>
                              )}
                              {hasPermission !== "Super Admin" &&
                                hasPermission !== "Vendor Admin" && (
                                  <Col
                                    xs={24}
                                    sm={24}
                                    md={12}
                                    lg={8}
                                    xxl={6}
                                    className="TextFeild gutter-row"
                                  >
                                    <Form.Item
                                      name="assign_site_employee"
                                      label="Site"
                                    >
                                      <Select
                                        className="cust-selectBox"
                                        mode="multiple"
                                        showArrow
                                        showSearch
                                        allowClear
                                        placeholder={t("Select site")}
                                        optionFilterProp="children"
                                        onChange={handleSiteChange}
                                        value={state.site}
                                        maxTagCount="responsive"
                                        style={{ width: '100%' }}
                                      >
                                        {siteEmployee &&
                                          siteEmployee.length > 0 &&
                                          siteEmployee.map((item) => (
                                            <Select.Option
                                              key={item.site_id}
                                              value={item.site_id}
                                            >
                                              {item.site_name}
                                            </Select.Option>
                                          ))}
                                      </Select>
                                    </Form.Item>
                                  </Col>
                                )}

                              <Col xs={24} sm={24} md={12} lg={8} xxl={6}>
                                <Form.Item
                                  name="role"
                                  label={t("label_role")}
                                  value={state.role}
                                >
                                  <Select
                                    showArrow
                                    mode="multiple"
                                     
                                    showSearch
                                    allowClear
                                    placeholder={t("label_role")}
                                    optionFilterProp="children"
                                    value={state.role}
                                    onChange={(value) =>
                                      handleRoleSelectChange(value)
                                    }
                                    maxTagCount="responsive"
                                    style={{ width: '100%' }}
                                  >
                                    {roleName.map((item) => (
                                      <Option key={item.id} value={item.id}>
                                        {item.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </Form.Item>
                              </Col>
                            </Row>
                          </Panel>
                        </Collapse>
                        <div className="sectiontitle"><span>Additional Permission</span></div>

                        <div className="steppermission">
                          {groupedPermissions &&
                            Object.entries(groupedPermissions).map(
                              ([modelName, permissions], index) => {
                                return (
                                  <NewPermissionPanelStep
                                    key={index}
                                    state={state}
                                    modelName={modelName}
                                    permissions={permissions}
                                    setState={setState}
                                    index={index}
                                  />
                                );
                              }
                            )}
                        </div>
                      </div>
                    </div>
                    </Spin>
                  </div>
                  <div className="stepsFooter">
                    <Button
                      cursor="pointer"
                      type="secondary"
                      className="primary"
                      onClick={() => navigate("/employee")}
                    >
                      Cancel
                    </Button>
                    <Button
                      cursor="pointer"
                      type="primary"
                      className="primary"
                      htmlType="submit"
                    >
                      Save
                    </Button>
                  </div>
           
          </Form>

   
    </>
  );
};

export default AddEmployee;
